import { AppTooltip } from '@components'
import type { PatternSpecificationEnum } from '@here/api'
import { Diamond } from 'lucide-solid'
import { type Component, Show } from 'solid-js'
import { Triangle } from './List/Card/Triangle'

type SlungBadgeProps = {
	patternSpecification?: PatternSpecificationEnum
}

const SlungBadge: Component<SlungBadgeProps> = (props) => {
	if (props.patternSpecification === undefined) return null
	return (
		<AppTooltip content={props.patternSpecification?.replaceAll('-', ' ')}>
			<Show
				when={props.patternSpecification === 'perfectly-symmetrical'}
				fallback={
					<Triangle
						direction={props.patternSpecification.includes('low') ? 'down' : 'up'}
						color={`var(--colors-${props.patternSpecification})`}
					/>
				}
			>
				<Diamond
					fill="#0098ff"
					stroke="#0098ff"
				/>
			</Show>
		</AppTooltip>
	)
}

export default SlungBadge
